
// const IMAGE_URL = "https://storage.cloud.google.com/mario-kart-graphics/"
const IMAGE_URL = "https://storage.googleapis.com/mario-kart-graphics/"

const CCLIST = {

    "ccs":
        [
            {
                "id": 1,
                "name": "50CC",
                "url": "cc_icons/50cc.png",
            },
            {
                "id": 2,
                "name": "100CC",
                "url": "cc_icons/100cc.png",
            },
            {
                "id": 3,
                "name": "150CC",
                "url": "cc_icons/150cc.png",
            },
            {
                "id": 4,
                "name": "EXTRA",
                "url": "cc_icons/Extra.png",
            },

        ]

}
const MAPS =
    [
        {
            "id": 1,
            "name": "Mushroom Cup",
            "url": "cups/active/MushroomCup.png",
            "races":
                [
                    {
                        "id": 1,
                        "name": "Luigi Raceway",
                        "url": "map_names/LuigiRaceway.png",
                        "mapImage": "maps/1_Luigi_Raceway_MK64.png",
                    },
                    {
                        "id": 2,
                        "name": "Moo Moo Farm",
                        "url": "map_names/MooMooFarm.png",
                        "mapImage": "maps/2_Moo_Moo_Farm_MK64.webp",
                    },
                    {
                        "id": 3,
                        "name": "Koopa Troopa Beach",
                        "url": "map_names/KoopaTroopaBeach.png",
                        "mapImage": "maps/3_Koopa_Troopa _Beach_MK64.webp",
                    },
                    {
                        "id": 4,
                        "name": "Kalimari Desert",
                        "url": "map_names/KalimariDesert.png",
                        "mapImage": "maps/4_Kalimari_Desert_MK64.webp",
                    },
                ]
        },
        {
            "id": 2,
            "name": "Flower Cup",
            "url": "cups/active/FlowerCup.png",
            "races":
                [
                    {
                        "id": 5,
                        "name": "Toad's Turnpike",
                        "url": "map_names/ToadsTurnpike.png",
                        "mapImage": "maps/5_Toad's_Turnpike_MK64.webp",
                    },
                    {
                        "id": 6,
                        "name": "Frappe Snowland",
                        "url": "map_names/FrappeSnowland.png",
                        "mapImage": "maps/6_Frappe_Snowland_MK64.webp",
                    },
                    {
                        "id": 7,
                        "name": "Choco Mountain",
                        "url": "map_names/ChocoMountain.png",
                        "mapImage": "maps/7_Choco_Mountain_MK64.webp",
                    },
                    {
                        "id": 8,
                        "name": "Mario Raceway",
                        "url": "map_names/MarioRaceway.png",
                        "mapImage": "maps/8_Mario_Raceway_MK64.webp",
                    }
                ]
        },
        {
            "id": 3,
            "name": "Star Cup",
            "url": "cups/active/StarCup.png",
            "races":
                [
                    {
                        "id": 9,
                        "name": "Wario Stadium",
                        "url": "map_names/WarioStadium.png",
                        "mapImage": "maps/9_Wario_Stadium_MK64.webp",
                    },
                    {
                        "id": 10,
                        "name": "Sherbet Land",
                        "url": "map_names/SherbetLand.png",
                        "mapImage": "maps/10_Sherbert_Land_MK64.webp",
                    },
                    {
                        "id": 11,
                        "name": "Royal Raceway",
                        "url": "map_names/RoyalRaceway.png",
                        "mapImage": "maps/11_Royal_Raceway_MK64.webp",
                    },
                    {
                        "id": 12,
                        "name": "Bowser's Castle",
                        "url": "map_names/BowsersCastle.png",
                        "mapImage": "maps/12_Bowser_Castle_MK64.webp",
                    }
                ]
        },
        {
            "id": 4,
            "name": "Special Cup",
            "url": "cups/active/SpecialCup.png",
            "races":
                [
                    {
                        "id": 13,
                        "name": "D.K.'s Jungle Parkway",
                        "url": "map_names/DKsJungleParkway.png",
                        "mapImage": "maps/13_DK_Jungle_Parkway_MK64.webp",
                    },
                    {
                        "id": 14,
                        "name": "Yoshi Valley",
                        "url": "map_names/YoshiValley.png",
                        "mapImage": "maps/14_Yoshi_Valley_MK64.webp",
                    },
                    {
                        "id": 15,
                        "name": "Banshee Boardwalk",
                        "url": "map_names/BansheeBoardwalk.png",
                        "mapImage": "maps/15_Banshee_Boardwalk_MK64.webp",
                    },
                    {
                        "id": 16,
                        "name": "Rainbow Road",
                        "url": "map_names/RainbowRoad.png",
                        "mapImage": "maps/16_Rainbow-road-n64.webp",
                    }
                ]
        },

    ]

const CHARACTERS = [
    {
        "id": '1',
        "name": "Mario",
        "url": "character_portraits/Mario_portrait.png",
        "rosterUrl": "roster_characters/Mario_portrait.png",
        "startColor": "#7A2019",
        "endColor": "#F54232",

    },
    {
        "id": '2',
        "name": "Luigi",
        "url": "character_portraits/Luigi_portrait.png",
        "rosterUrl": "roster_characters/Luigi_portrait.png",
        "startColor": "#18681E",
        "endColor": "#69A86E",
    },
    {
        "id": '3',
        "name": "Peach",
        "url": "character_portraits/Peach_portrait.png",
        "rosterUrl": "roster_characters/Peach_portrait.png",
        "startColor": "#711F3C",
        "endColor": "#E63976",
    },
    {
        "id": '4',
        "name": "Toad",
        "url": "character_portraits/Toad_portrait.png",
        "rosterUrl": "roster_characters/Toad_portrait.png",
        "startColor": "#2D3B7B",
        "endColor": "#5A6DC3",
    },
    {
        "id": '5',
        "name": "Yoshi",
        "url": "character_portraits/Yoshi_portrait.png",
        "rosterUrl": "roster_characters/Yoshi_portrait.png",
        "startColor": "#2B7622",
        "endColor": "#97DF8E",
    },
    {
        "id": '6',
        "name": "Donkey Kong",
        "url": "character_portraits/DK_portrait.png",
        "rosterUrl": "roster_characters/DK_portrait.png",
        "startColor": "#8E8E21",
        "endColor": "#D9D956",
    },
    {
        "id": '7',
        "name": "Wario",
        "url": "character_portraits/Wario_portrait.png",
        "rosterUrl": "roster_characters/Wario_portrait.png",
        "startColor": "#532C6B",
        "endColor": "#9C63BF",
    },
    {
        "id": '8',
        "name": "Bowser",
        "url": "character_portraits/Bowser_portrait.png",
        "rosterUrl": "roster_characters/Bowser_portrait.png",
        "startColor": "#67271B",
        "endColor": "#CD4E36",
    },
    {
        "id": '9',
        "name": "Beeg Yoshi",
        "url": "character_portraits/Beeg_Yoshi.png",
        "rosterUrl": "roster_characters/Beeg_Yoshi.png",
        "startColor": "#2A7321",
        "endColor": "#AEE6A7",
    },
]

const RULES = {
    '0': "No Rotation",
    '1': "Bottom 1 Stays",
    '2': "Bottom 2 Stay",
    '3': "Bottom 3 Stay",
    '4': "Full Rotation",
    '5': "Please Edit Parameters",
    '6': "Undefined Rules"
}

const GAMEMODES = [
    { "id": 0, "name": "Normal", "url": "game_modes/Normal.png" },
    { "id": 1, "name": "Hardcore", "url": "game_modes/Hardcore.png" }
]

const COURSE_LIST = [
    {
        "courseId": 1,
        "name": "Luigi Raceway",
    },
    {
        "courseId": 2,
        "name": "Moo Moo Farm",
    },
    {
        "courseId": 3,
        "name": "Koopa Troopa Beach",
    },
    {
        "courseId": 4,
        "name": "Kalimari Desert",
    },
    {
        "courseId": 5,
        "name": "Toad's Turnpike",
    },
    {
        "courseId": 6,
        "name": "Frappe Snowland",
    },
    {
        "courseId": 7,
        "name": "Choco Mountain",
    },
    {
        "courseId": 8,
        "name": "Mario Raceway",
    },
    {
        "courseId": 9,
        "name": "Wario Stadium",
    },
    {
        "courseId": 10,
        "name": "Sherbet Land",
    },
    {
        "courseId": 11,
        "name": "Royal Raceway",
    },
    {
        "courseId": 12,
        "name": "Bowser's Castle",
    },
    {
        "courseId": 13,
        "name": "D.K.'s Jungle Parkway",
    },
    {
        "courseId": 14,
        "name": "Yoshi Valley",
    },
    {
        "courseId": 15,
        "name": "Banshee Boardwalk",
    },
    {
        "courseId": 16,
        "name": "Rainbow Road",
    }
]

module.exports = {
    MAPS,
    IMAGE_URL,
    CCLIST,
    RULES,
    CHARACTERS,
    GAMEMODES,
    COURSE_LIST
}
